/** 
 * LOGIN-APP
 * Login to application
 */

import { useEffect, useState } from "react"
import { withTranslation, WithTranslation } from 'react-i18next';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { firebaseAppAuth } from "@/App";
import { toast } from 'react-toastify';
import TextInput from "@/components/text-input";
import Button from "@/components/button";
import Card from "@/components/card";
import NavLogin from "@/nav/nav.login";
import Space from "@/components/space";
import Link from "@/components/link";
import LoginIconWidget from "@/widgets/login-icon.widget";
import LoginModal from "@/modals/login.modal";
import { sendPasswordResetEmail } from "firebase/auth";
import isTablet from "@/utils/is-tablet.utils"
 
type Props = WithTranslation

const MODAL_LOGIN = "MODAL_LOGIN"

function LoginApp(props: Props){
  const { t } = props
  const navigate: NavigateFunction = useNavigate()
  const isTabletMode = isTablet()

  const emailUrl: string | null = new URLSearchParams(window.location.search).get("email")
  const message: string | null = new URLSearchParams(window.location.search).get("message")

  const [currentModal, setCurrentModal] = useState<string | null>(null)
  const [email, setEmail] = useState<string>(emailUrl ? emailUrl : "")
  const [password, setPassword] = useState<string>("")
  const [withGoogle, setWithGoogle] = useState<boolean>(false)


  //On load
  //If message display on bottom
  useEffect(() => {
    if (message){
      toast(t(message), { type : 'error' })
    }
  }, [
    message
  ])

  useEffect(() => {
    if (email){
      setEmail(email)
    }
  }, [
    email
  ])



  //Submit form
  //> check email before
  async function handleSubmit(event: any){
    event.preventDefault()
    if (validateForm()){
      setCurrentModal(MODAL_LOGIN)
      setWithGoogle(false)
    }
  }

  //Reset password
  function resetPassword(){
    sendPasswordResetEmail(firebaseAppAuth, email).then(() => {
      toast(t("utils_email_send", { email : email }))
    }).catch(error => {
      toast(t("firebase_" + error.code ), { type : 'error' })
    })
  }

  //Login google
  function signInWithGoogle(){
    setCurrentModal(MODAL_LOGIN)
    setWithGoogle(true)
  }

  //Confirm if form can be send
  function validateForm(){
    return email.length > 0 && password.length > 0
  }

  return(
    <NavLogin>

      { currentModal === MODAL_LOGIN &&
      <LoginModal authLevel={2}
        email={email}
        password={password}
        onClose={() => setCurrentModal(null)}
        withGoogle={withGoogle}
      />
      }

      <LoginIconWidget/>

      <div className="flex" style={isTabletMode ? { alignItems: "center" } : undefined}>

        <Space/>

        <div style={isTabletMode ? { width: 460, maxWidth: "calc(100vw - 80px)" } : undefined}>

          <Card
            title={isTabletMode ? undefined : t("utils_connect_idtree")}
            style={isTabletMode ? { borderRadius: 24, padding: "34px 40px", boxShadow: "0 24px 60px rgba(0,0,0,0.18)" } : undefined}>
            
            <form className="flex flex-dcol"
              onSubmit={ handleSubmit }>

              {isTabletMode && (
                <div className="mb-24">
                  <div className="text-2xl font-bold">{t("utils_connect_idtree")}</div>
                  <div className="grey-t mt-6">Connectez-vous à votre espace IDTree.</div>
                </div>
              )}

              <TextInput
                title={t("user_email")}
                id="email" 
                isFullWidth
                value={ email }
                onChange={(event: any) => setEmail(event.value)}
                type="email"
                autoFocus
                disabledClickForTablet
                autoComplete="email"
              />
                
              <TextInput
                autoComplete="current-password"
                title={t("utils_password")}
                id="password"
                isFullWidth
                value={ password }
                onChange={(event: any) => setPassword(event.value)}
                type="password"
                disabledClickForTablet
              />

              <div className="flex mt-4">
                <Space/>
                <Link onClick={resetPassword}>
                  {t("self_password_forget")}
                </Link>
              </div>

              <div className={isTabletMode ? "height-30" : "height-20"}/>
              
              <Button type="submit" 
                isLarge
                className="primary" 
                isFullWidth>
                {t("utils_connect")}
              </Button>

              <div className={isTabletMode ? "height-20" : "height-10"}/>
          
              <Card onClick={signInWithGoogle}
                isWithoutPadding
                className="_hover"
                style={isTabletMode ? { borderRadius: 14 } : undefined}>
                <div className="flex" style={{padding: isTabletMode ? "18px 20px" : "20px"}}>

                  <Space/>

                  <img src={require("@/assets/google.png")}
                    alt="google"
                    style={{
                      width : '20px',
                      height : '20px',
                      marginRight : '20px'
                    }}
                  />
                  
                  <div className="grey-t">
                    <b>{t("sso_google_button")}</b>
                  </div>
                  
                  <Space/>

                </div>
              </Card>
    
            </form>

          </Card>

        </div>
        
        <Space/>

      </div>

      {/** link at the bottom of the page */}
      <div className="flex">
        <Space/>
        <Link isWhite
          onClick={() => navigate("/login/register")}>
          {t("self_password_create")}
        </Link>
        <Space/>
      </div>

      <Space/>
      
    </NavLogin>

  )
}

export default withTranslation()(LoginApp)
